import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    title: 'Finance ONE - Det hurtigste regnskabsprogram'
  },
  {
    path: 'funktioner',
    loadComponent: () => import('./pages/features/features.component').then(m => m.FeaturesComponent),
    title: 'Funktioner - Finance ONE'
  },
  {
    path: 'priser',
    loadComponent: () => import('./pages/pricing/pricing.component').then(m => m.PricingComponent),
    title: 'Priser - Finance ONE'
  },
  {
    path: 'guides',
    loadComponent: () => import('./pages/guides/guides-list.component').then(m => m.GuidesListComponent),
    title: 'Guides - Finance ONE'
  },
  {
    path: 'guides/:slug',
    loadComponent: () => import('./pages/guides/guide-detail.component').then(m => m.GuideDetailComponent),
    title: 'Guide - Finance ONE'
  },
  {
    path: 'nyheder',
    loadComponent: () => import('./pages/nyheder/nyheder.component').then(m => m.NyhederComponent),
    title: 'Nyheder - Finance ONE'
  },
  {
    path: 'om-os',
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent),
    title: 'Om os - Finance ONE'
  },
  {
    path: 'kontakt',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent),
    title: 'Kontakt - Finance ONE'
  },
  {
    path: 'tilmelding-som-virksomhed',
    loadComponent: () => import('./pages/tilmelding-virksomhed/tilmelding-virksomhed.component').then(m => m.TilmeldingVirksomhedComponent),
    title: 'Tilmeld din virksomhed - Finance ONE'
  },
  {
    path: 'admin/mockup-builder',
    loadComponent: () => import('./admin/mockup-builder/mockup-builder-new.component').then(m => m.MockupBuilderNewComponent),
    title: 'Mockup Builder - Admin'
  },
  {
    path: 'admin/builder',
    loadComponent: () => import('./admin/mockup-builder/builder-shell.component').then(m => m.BuilderShellComponent),
    title: 'Builder (New) - Admin'
  },
  {
    path: 'admin/layoutdemo',
    loadComponent: () => import('./admin/layout-demo/layout-demo.component').then(m => m.LayoutDemoComponent),
    title: 'Layout Engine Demo - Admin'
  },
  {
    path: 'admin',
    redirectTo: 'admin/mockup-builder',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
